import React, { useEffect } from "react";
import moment from "moment";

const tempMoment = moment;

const Timer = (props) => {
  // console.log("props.time", props.time)
  const [timeString, setTimeString] = React.useState(null);
  const [state, setState] = React.useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    if (props.time === '2022-01-31 02:21:50') {
    }
    if (props.time) {
      setTimeString(props.time);
    } else {
      setTimeString(tempMoment().format("YYYY-MM-DD HH:mm:ss"));
    }
  }, [props.time]);
  // ,[props.time]

  useEffect(() => {
    if (timeString) {
      getTimeDifference(
        tempMoment(timeString, "YYYY-MM-DD HH:mm:ss").format(
          "YYYY-MM-DD HH:mm:ss"
        )
      );
      // setInterval(
      //   () =>
      //     getTimeDifference(
      //       tempMoment(timeString, "YYYY-MM-DD HH:mm:ss").format(
      //         "YYYY-MM-DD HH:mm:ss"
      //       )
      //     ),
      //   1000
      // );
    }
  }, [timeString]);

  const leadingZero = (num) => {
    return num > -10 && num < 10 ? "0" + Math.abs(num) : Math.abs(num);
  };

  const getTimeDifference = (eventDate) => {
    // let time = Date.parse(new Date()) - Date.parse(eventDate);

    // console.log(timeString);
    let time = Date.parse(new Date()) - Date.parse(tempMoment(timeString, "YYYY-MM-DD HH:mm:ss").format(
      "YYYY-MM-DD HH:mm:ss"
    ));
    // console.log(time);
    // const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor(time / (1000 * 60 * 60)); // (% 24) get 24-hours format hour value
    const minutes = Math.floor((time / 1000 / 60) % 60);
    const seconds = Math.floor((time / 1000) % 60);
    // setState({ hours, minutes, seconds });

    
    let curTime = leadingZero(hours) +
      ":" +
      leadingZero(minutes) +
      ":" +
      leadingZero(seconds)
      // console.log(curTime);
    return curTime
  };


  return (
    // <>
    //   {leadingZero(state.hours) +
    //     ":" +
    //     leadingZero(state.minutes) +
    //     ":" +
    //     leadingZero(state.seconds)}
    // </>

    <>
      {timeString &&
        getTimeDifference(
          timeString
        )
      }
    </>
  );
};

export default Timer;
